<template>
  <PSidebar
    v-if="isMobile"
    v-model:visible="statusSidebarPesquisa"
    :base-z-index="$lg.config.zIndex.sidebar"
    :aria-close-label="$t_v2('43985', 'Fechar')"
    position="top"
    class="lg-aa-barra-pesquisa__sidebar"
    @show="focarInputAutocomplete"
  >
    <LGBarraPesquisa
      :id="id"
      class="p-mt-1"
      :mobile="true"
      :itens-pesquisados="itensPesquisados"
      @pesquisar-change="selecionarItemPesquisa"
      @pesquisar="efetuarPesquisa"
    />
  </PSidebar>
</template>

<script>
import { UniqueComponentId } from 'primevue/utils';
import LGBarraPesquisa from 'lg-vue-components/barraPesquisa';
import PSidebar from 'primevue/sidebar';

export default {
  name: 'LGSidebarPesquisa',
  components: {
    LGBarraPesquisa,
    PSidebar,
  },
  props: {
    itensPesquisados: {
      type: Array,
      default: () => [],
    },
  },
  emits: [
    'pesquisar-change',
    'pesquisar',
  ],
  data() {
    return {
      id: UniqueComponentId('lg_aa_'),
    };
  },
  computed: {
    isMobile() {
      return this.$lg.breakpoint.xsOnly;
    },
    statusSidebarPesquisa: {
      set(valor) {
        this.$store.commit('layout/setSidebarPesquisaAtiva', valor);
      },
      get() {
        return this.$store.state.layout.statusSidebarPesquisa;
      },
    },
  },
  watch: {
    isMobile(newValue) {
      if (!newValue) {
        this.statusSidebarPesquisa = true;
      }
    },
  },
  mounted() {
    if (this.$eventBus) {
      this.$eventBus.on('forcarFechamentoSidebarPesquisa', this.forcarFechamentoSidebarPesquisa);
      this.$eventBus.on('toggleBarraPesquisaMobile', this.abrirSidebarPesquisa);
    }
  },
  unmounted() {
    if (this.$eventBus) {
      this.$eventBus.off('forcarFechamentoSidebarPesquisa');
      this.$eventBus.off('toggleBarraPesquisaMobile');
    }
  },
  methods: {
    abrirSidebarPesquisa() {
      this.statusSidebarPesquisa = false;
    },
    forcarFechamentoSidebarPesquisa() {
      this.statusSidebarPesquisa = true;
    },
    focarInputAutocomplete() {
      setTimeout(() => {
        const el = document.querySelector(`#${this.id} input.p-autocomplete-input`);

        if (el) {
          el.focus();
        }
      }, 100);
    },
    selecionarItemPesquisa(item) {
      this.statusSidebarPesquisa = true;
      this.$emit('pesquisar-change', item);
    },
    efetuarPesquisa(termoPesquisa) {
      this.$emit('pesquisar', termoPesquisa);
    },
  },
};
</script>
